import {Deal, PaymentCurrencyType} from "@irati/types"
import {BasketInputItem, BasketItemType} from "@irati/types/ops"
import authentication from "@irati/auth"
import {productCount, productItemLimit} from "@irati/deals/helpers/redemption/deal"
import basketUtil from "../../basket"
import Screen from "../enum/Screen"
import basketService from "../../../services/basket"
import checkoutService from "../../../services/checkout"
import {Details} from ".."

export default async function handleSingleProduct(deal: Deal): Promise<Details> {
  const userId = authentication.user().uuid!
  const isRewards = deal.productConfig?.products[0]?.salePrice?.currency === PaymentCurrencyType.Rp

  let entityType = isRewards ? BasketItemType.FlexiReward : BasketItemType.Deal
  // TODO use enum
  if (deal.type === "MERCHANDISE") {
    entityType = BasketItemType.Merchandise
  }

  const basketItem: BasketInputItem = {
    entityId: deal.uuid!,
    entityType,
    targetUserId: userId,
    productId: deal.productConfig?.products[0].uuid,
    count: 1
  }
  basketUtil.items = [basketItem]
  const basket = await basketService.updateBasket({items: [basketItem], userId, isRewards})
  await basketService.canRedeemBasket(userId, {fetchPolicy: "no-cache"})
  if (basket.total?.amount! > 0) {
    return {screen: Screen.DealPayment, deal}
  }

  const checkout = await checkoutService.startCheckout(userId)
  const completeCheckout = await checkoutService.completeCheckout(checkout.uuid!)
  const redemptionId = completeCheckout.fullRedemptions[0].uuid
  return {screen: Screen.DealSuccess, deal, checkoutId: checkout.uuid, redemptionId}
}

export function isSingleProduct(deal: Deal) {
  return productItemLimit(deal) === 1 && productCount(deal) === 1
}
